/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Citizen } from '../models';
// @ts-ignore
import type { InputSaveSignature } from '../models';
// @ts-ignore
import type { InputUpdateCitizenMe } from '../models';
// @ts-ignore
import type { InputUpdateQuestionnaireFields } from '../models';
// @ts-ignore
import type { ResponseGetIsee } from '../models';
// @ts-ignore
import type { ResponseGetQuestionnaireFields } from '../models';
// @ts-ignore
import type { ServiceHistoryResponse } from '../models';
/**
 * CitizenApi - axios parameter creator
 * @export
 */
export const CitizenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Family update me
         * @param {InputUpdateCitizenMe} [inputUpdateCitizenMe] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        familyUpdateMe: async (inputUpdateCitizenMe?: InputUpdateCitizenMe, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/citizen/family/updateMe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputUpdateCitizenMe, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get isee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIsee: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/citizen/isee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get questionnaire fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionnaireFields: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/citizen/questionnaire`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get history service collection of current citizen
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServicesHistory: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/citizen/history/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save signature
         * @param {InputSaveSignature} [inputSaveSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSignature: async (inputSaveSignature?: InputSaveSignature, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/citizen/signature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputSaveSignature, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update questionnaire fields
         * @param {InputUpdateQuestionnaireFields} [inputUpdateQuestionnaireFields] update questionnaire fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionnaireFields: async (inputUpdateQuestionnaireFields?: InputUpdateQuestionnaireFields, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/citizen/questionnaire`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputUpdateQuestionnaireFields, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CitizenApi - functional programming interface
 * @export
 */
export const CitizenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CitizenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Family update me
         * @param {InputUpdateCitizenMe} [inputUpdateCitizenMe] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async familyUpdateMe(inputUpdateCitizenMe?: InputUpdateCitizenMe, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Citizen>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.familyUpdateMe(inputUpdateCitizenMe, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CitizenApi.familyUpdateMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get isee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIsee(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGetIsee>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIsee(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CitizenApi.getIsee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get questionnaire fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionnaireFields(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGetQuestionnaireFields>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionnaireFields(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CitizenApi.getQuestionnaireFields']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get history service collection of current citizen
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServicesHistory(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServicesHistory(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CitizenApi.getServicesHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save signature
         * @param {InputSaveSignature} [inputSaveSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSignature(inputSaveSignature?: InputSaveSignature, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Citizen>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSignature(inputSaveSignature, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CitizenApi.saveSignature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update questionnaire fields
         * @param {InputUpdateQuestionnaireFields} [inputUpdateQuestionnaireFields] update questionnaire fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQuestionnaireFields(inputUpdateQuestionnaireFields?: InputUpdateQuestionnaireFields, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuestionnaireFields(inputUpdateQuestionnaireFields, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CitizenApi.updateQuestionnaireFields']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CitizenApi - factory interface
 * @export
 */
export const CitizenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CitizenApiFp(configuration)
    return {
        /**
         * 
         * @summary Family update me
         * @param {InputUpdateCitizenMe} [inputUpdateCitizenMe] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        familyUpdateMe(inputUpdateCitizenMe?: InputUpdateCitizenMe, options?: RawAxiosRequestConfig): AxiosPromise<Citizen> {
            return localVarFp.familyUpdateMe(inputUpdateCitizenMe, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get isee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIsee(options?: RawAxiosRequestConfig): AxiosPromise<ResponseGetIsee> {
            return localVarFp.getIsee(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get questionnaire fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionnaireFields(options?: RawAxiosRequestConfig): AxiosPromise<ResponseGetQuestionnaireFields> {
            return localVarFp.getQuestionnaireFields(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get history service collection of current citizen
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServicesHistory(limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceHistoryResponse> {
            return localVarFp.getServicesHistory(limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save signature
         * @param {InputSaveSignature} [inputSaveSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSignature(inputSaveSignature?: InputSaveSignature, options?: RawAxiosRequestConfig): AxiosPromise<Citizen> {
            return localVarFp.saveSignature(inputSaveSignature, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update questionnaire fields
         * @param {InputUpdateQuestionnaireFields} [inputUpdateQuestionnaireFields] update questionnaire fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionnaireFields(inputUpdateQuestionnaireFields?: InputUpdateQuestionnaireFields, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateQuestionnaireFields(inputUpdateQuestionnaireFields, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CitizenApi - interface
 * @export
 * @interface CitizenApi
 */
export interface CitizenApiInterface {
    /**
     * 
     * @summary Family update me
     * @param {InputUpdateCitizenMe} [inputUpdateCitizenMe] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CitizenApiInterface
     */
    familyUpdateMe(inputUpdateCitizenMe?: InputUpdateCitizenMe, options?: RawAxiosRequestConfig): AxiosPromise<Citizen>;

    /**
     * 
     * @summary Get isee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CitizenApiInterface
     */
    getIsee(options?: RawAxiosRequestConfig): AxiosPromise<ResponseGetIsee>;

    /**
     * 
     * @summary Get questionnaire fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CitizenApiInterface
     */
    getQuestionnaireFields(options?: RawAxiosRequestConfig): AxiosPromise<ResponseGetQuestionnaireFields>;

    /**
     * 
     * @summary Get history service collection of current citizen
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CitizenApiInterface
     */
    getServicesHistory(limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceHistoryResponse>;

    /**
     * 
     * @summary Save signature
     * @param {InputSaveSignature} [inputSaveSignature] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CitizenApiInterface
     */
    saveSignature(inputSaveSignature?: InputSaveSignature, options?: RawAxiosRequestConfig): AxiosPromise<Citizen>;

    /**
     * 
     * @summary Update questionnaire fields
     * @param {InputUpdateQuestionnaireFields} [inputUpdateQuestionnaireFields] update questionnaire fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CitizenApiInterface
     */
    updateQuestionnaireFields(inputUpdateQuestionnaireFields?: InputUpdateQuestionnaireFields, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * CitizenApi - object-oriented interface
 * @export
 * @class CitizenApi
 * @extends {BaseAPI}
 */
export class CitizenApi extends BaseAPI implements CitizenApiInterface {
    /**
     * 
     * @summary Family update me
     * @param {InputUpdateCitizenMe} [inputUpdateCitizenMe] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CitizenApi
     */
    public familyUpdateMe(inputUpdateCitizenMe?: InputUpdateCitizenMe, options?: RawAxiosRequestConfig) {
        return CitizenApiFp(this.configuration).familyUpdateMe(inputUpdateCitizenMe, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get isee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CitizenApi
     */
    public getIsee(options?: RawAxiosRequestConfig) {
        return CitizenApiFp(this.configuration).getIsee(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get questionnaire fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CitizenApi
     */
    public getQuestionnaireFields(options?: RawAxiosRequestConfig) {
        return CitizenApiFp(this.configuration).getQuestionnaireFields(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get history service collection of current citizen
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CitizenApi
     */
    public getServicesHistory(limit?: number, options?: RawAxiosRequestConfig) {
        return CitizenApiFp(this.configuration).getServicesHistory(limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save signature
     * @param {InputSaveSignature} [inputSaveSignature] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CitizenApi
     */
    public saveSignature(inputSaveSignature?: InputSaveSignature, options?: RawAxiosRequestConfig) {
        return CitizenApiFp(this.configuration).saveSignature(inputSaveSignature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update questionnaire fields
     * @param {InputUpdateQuestionnaireFields} [inputUpdateQuestionnaireFields] update questionnaire fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CitizenApi
     */
    public updateQuestionnaireFields(inputUpdateQuestionnaireFields?: InputUpdateQuestionnaireFields, options?: RawAxiosRequestConfig) {
        return CitizenApiFp(this.configuration).updateQuestionnaireFields(inputUpdateQuestionnaireFields, options).then((request) => request(this.axios, this.basePath));
    }
}

